import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { X, AlertTriangle, Megaphone } from "lucide-react";

export const SiteAlertBanner = () => {
  const [banner, setBanner] = useState<any>(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    supabase
      .from("site_banners")
      .select("*")
      .eq("is_active", true)
      .in("kind", ["alert", "notice", "announcement"])
      .order("created_at", { ascending: false })
      .limit(1)
      .maybeSingle()
      .then(({ data }) => setBanner(data));
  }, []);

  if (!banner || dismissed) return null;

  const isAlert = banner.kind === "alert";
  const Icon = isAlert ? AlertTriangle : Megaphone;
  const cls = isAlert
    ? "bg-destructive text-destructive-foreground"
    : banner.kind === "notice"
    ? "bg-accent text-accent-foreground"
    : "bg-primary text-primary-foreground";

  const Content = (
    <div className="flex items-center gap-3">
      <Icon className="h-4 w-4 shrink-0" />
      <span className="text-sm font-semibold">{banner.title}</span>
      {banner.message && <span className="hidden text-sm opacity-90 sm:inline">: {banner.message}</span>}
    </div>
  );

  return (
    <div className={`${cls} relative`}>
      <div className="container-cws flex items-center justify-between gap-3 py-2.5">
        {banner.link_url ? (
          <Link to={banner.link_url} className="hover:underline">{Content}</Link>
        ) : Content}
        <button onClick={() => setDismissed(true)} aria-label="Dismiss" className="opacity-80 hover:opacity-100">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
